<template>
<div class="A4 font-c">
    <div class="x_body">
        <h3 class="text-center font-m" style="font-weight: bold; font-size: 14pt;">ការបញ្ជាលក់/ORDER</h3>
        <p class="text-center">Tel: 095 615 758 / 010 877 420</p>
        <div class="row">
            <div class="col-sm-6">
                <table class="table-print">
                    <tbody>
                        <tr>
                            <td style="width: 180px;">អតិថិជន/Customer</td>
                            <td style="width: 15px;">:</td>
                            <td>{{customer.Name}}</td>
                        </tr>
                        <tr>
                            <td>អាស័យដ្ឋាន/Address</td>
                            <td class="v-top" style="width: 15px;">:</td>
                            <td class="v-top">{{customer.Address}}</td>
                        </tr>
                        <tr>
                            <td>អ្នកតំណាងលក់/Saller</td>
                            <td style="width: 15px;">:</td>
                            <td>{{employee.KhmerName}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-sm-6">
                <table class="table-print" align="right">
                    <tbody>
                        <tr>
                            <td style="width: 120px;">លេខបញ្ជាលក់</td>
                            <td style="width: 15px;">:</td>
                            <td>{{invoice.Num}}</td>
                        </tr>
                        <tr>
                            <td>កាលបរិច្ឆេទ</td>
                            <td>:</td>
                            <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <br/>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-sm no-bor">
                    <thead>
                        <tr class="text-center">
                            <th class="text-center" style="width: 50px;">ល.រ <br>No</th>
                            <th>បរិយាយ <br> Description of Goods </th>
                            <th style="width: 70px;">ចំនួន <br>Quantity</th>
                            <th style="width: 80px;">ឯកតា <br>Uom</th>
                            <th style="width: 70px;">តម្លៃ <br>Price</th>
                            <th style="width: 85px;">សរុបរង <br>Sub Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret,index) in lines" :key="ret.Id">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.ItemName}}</td>
                            <td class="text-center">{{ret.Quantity}}</td>
                            <td class="text-center">{{ret.UomName}}</td>
                            <td class="text-right">{{$money(ret.Price)}}</td>
                            <td class="text-right">{{$money(ret.SubTotal)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="5" class="text-right">{{$t('untax_amount')}}:</th>
                            <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
                        </tr>
                        <tr>
                            <th colspan="5" class="text-right">{{$t('discount')}}:</th>
                            <th class="text-right">{{$money(invoice.Discount)}}</th>
                        </tr>
                        <tr>
                            <th colspan="5" class="text-right">{{$t('total')}}:</th>
                            <th class="text-right">{{$money(invoice.PaidAmount)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="footer" style="padding: 20px 50px;">
            <div style="display: flex; justify-content: space-between">
                <div class="text-center">
                    <div>ហត្តលេខា​និងឈ្មោះអ្នកលក់</div>
                    <div>Seller's Signature & Name</div>
                </div>
                <div class="text-center">
                    <div>ហត្តលេខា​និងឈ្មោះអ្នកដឹកជញ្ជូន</div>
                    <div>Delivery's Signature & Name</div>
                </div>
                <div>
                    <div style="margin-left: 20px">ហត្តលេខា​និងឈ្មោះអ្នកទិញ</div>
                    <div style="margin-left: 10px">Customer's Signature & Name</div>
                    <div style="height: 100px;"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group" style="display: flex">
                    <label class="control-lable" style="margin-right: 10px">{{ $t('noted') }}: </label>
                    <div>{{invoice.Description}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        data: function(){
            return {
                company: {},
                invoice: {},
                customer: {},
                employee: {},
                lines: []
            }
        },
        created: function(){
            this.getCompany();
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                this.$api().post('sale/order/find', { Id: id }).then(res => {
                    var data = res.data.Json;
                    this.invoice = data.Header;
                    this.lines = data.Lines;
                    this.customer = data.Customer;
                    if(data.Employee != null)
                        this.employee = data.Employee;
                }).finally(function(){ loading.hide(); });
            }
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            }
        }
    }
</script>
<style scoped>
    .font-c *{
        font-size: 15pt;
    }
    @media print{
        .font-c *{
            font-size: 16pt;
        }
        .table td,
        .table th{
            border-color: black !important;
        }
    }
</style>